import styled from 'styled-components';

// Wrapper to allow proper positioning of the number circle
export const CardWrapper = styled.div`
	position: relative;

	@media (max-width: 1440px) {
		width: 280px;
	}

	@media (max-width: 1366px) {
		width: 260px;
	}
`;

// Styled components with classic styling for rectangular layout
export const CardContainer = styled.div`
	width: 100%;
	height: 100%;
	background-color: white;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	overflow: hidden; /* Keep this to hide image overflow */
	transition: transform 0.3s ease, box-shadow 0.3s ease;

	&:hover {
		cursor: pointer;
		transform: translateY(-5px);
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	}
`;

export const ImageWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 114px;

	@media (max-width: 1440px) {
		height: 89px;
	}

	@media (max-width: 1366px) {
		& > * {
			height: calc(25vh - 10px); /* Set height dynamically */
		}
	}
`;

export const CardImage = styled.div`
	width: 100%;
	height: 100%;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.5s ease;
	}

	&:hover img {
		cursor: pointer;
		transform: scale(1.05);
	}
`;

export const NumberCircle = styled.div`
	position: absolute;
	top: -5px;
	left: -5px;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background-color: white;
	border: 2px solid #3f7b25;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	font-size: 15px;
	z-index: 10;
	color: #3f7b25;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);

	@media (max-width: 1440px) {
		width: 36px;
		height: 36px;
		font-size: 16px;
	}

	@media (max-width: 1366px) {
		width: 32px;
		height: 32px;
		font-size: 15px;
	}
`;

export const ContentSection = styled.div`
	padding: 5px;

	@media (max-width: 1440px) {
		padding: 18px;
	}

	@media (max-width: 1366px) {
		padding: 16px;
	}
`;

export const TitleText = styled.h3`
	font-size: 18px;
	font-weight: 600;
	color: #3f7b25;

	line-height: 1;

	@media (max-width: 1440px) {
		font-size: 16px;
		margin-bottom: 8px;
	}

	@media (max-width: 1366px) {
		font-size: 15px;
		margin-bottom: 6px;
	}
`;

export const DescriptionText = styled.p`
	font-size: 14px;
	line-height: 1.5;
	color: #555;
	margin: 0;

	@media (max-width: 1440px) {
		font-size: 13px;
	}

	@media (max-width: 1366px) {
		font-size: 12px;
	}
`;

// Grid layout for displaying multiple cards
export const CardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
	gap: 20px;
	padding: 24px;

	@media (max-width: 1440px) {
		grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	}

	@media (max-width: 1366px) {
		grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	}
`;

export const Connector = styled.div`
	display: inline-block;
	position: relative;
	left: 93px;
	bottom: 17px;

	@media (max-width: 1440px) {
		left: 87px;
		bottom: 25px;
	}

	@media (max-width: 1366px) {
		left: 90px;
		bottom: 35px;
	}
`;

// Module Card
export const ModuleCard = styled.div`
	height: 48%;
	width: fit-content;
	background-color: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
	}
`;

// Module Header
export const ModuleHeader = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`;

// Module Header Content
export const ModuleHeaderContent = styled.div`
	flex-grow: 1;
	padding: 10px;
`;

// Module Number
export const ModuleNumber = styled.div`
	position: absolute;
	top: 11%;
	left: 80%;
	width: 1.4rem;
	height: 1.4rem;
	border-radius: 50%;
	background-color: white;
	border: 1px solid #3f7b25;
	display: flex;
	opacity: 0.7;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	font-size: 0.7rem;
	z-index: 10;
	color: #3f7b25;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
`;

// Module Icon
export const ModuleIcon = styled.div`
	width: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	margin-right: -7px;
	margin-top: 62px;
	color: black;
	font-size: 20px;
`;

// Module Title
export const ModuleTitle = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: #3f7b25;

	line-height: 1;

	@media (max-width: 1440px) {
		font-size: 16px;
		margin-bottom: 8px;
	}

	@media (max-width: 1366px) {
		font-size: 15px;
		margin-bottom: 6px;
	}
`;

// Module Subtitle
export const ModuleSubtitle = styled.div`
	font-size: 12px;
	line-height: 1.5;
	color: #555;
	margin: 0;
`;

export const ModuleSubtitle2 = styled.div`
	font-size: 12px;
	line-height: 1.5;
	color: #555;
	margin: 0;
`;

// Module Body
export const ModuleBody = styled.div`
	padding-left: 5px;
	padding-top: -11px;
	padding-right: 5px;
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
`;

// Module Image
export const ModuleImage = styled.img`
	margin-top: -68px;
	margin-bottom: -55px;
	width: 100%;
	// height: 100%;
	height: 100%;
	object-fit: cover;
`;

// Module Overlay
export const ModuleOverlay = styled.div`
	// position: absolute;
	// top: 0;
	// left: 0;
	// right: 0;
	// bottom: 0;
`;

// Module Footer
export const ModuleFooter = styled.div`
	padding-top: 0px;
	padding-bottom: 7px;
	text-align: center;
`;

// Module Footer Link
export const ModuleFooterLink = styled.a`
	text-decoration: none;
	font-size: 14px;
	color: #3f7b25;
	transition: color 0.3s ease;
	font-weight: 600;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
`;
